import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getBackgroundSurface } from './dashboardUtils';
import ComponentRenderer from '@helper/ComponentRenderer/ComponentRenderer';
const BackgroundRenderer = ({ config, passedProps, onConfigureRequest }) => {
    // Defer mount by one animation frame so the overlay dashboard renders before the
    // background component starts its (potentially heavy) sync init (WebGL, SVG, etc.).
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        const id = requestAnimationFrame(() => setMounted(true));
        return () => cancelAnimationFrame(id);
    }, []);
    if (!(config === null || config === void 0 ? void 0 : config.type) || !mounted)
        return null;
    const surface = getBackgroundSurface(config.type);
    if (!surface)
        return null;
    const configs = surface.props
        ? { props: surface.props }
        : undefined;
    const instance = {
        _id: surface.type,
        id: surface.type,
        key: surface.type,
        name: surface.label,
        component: surface.component,
        configs,
        configuredProps: config.props || {},
        hasConfigured: Object.keys(config.props || {}).length > 0,
    };
    return (_jsx("div", { className: "uxpcore_dashboard__background-renderer", children: _jsx(ComponentRenderer, { componentInstance: instance, additionalProps: passedProps, onConfigureRequest: onConfigureRequest, configNeededMessage: "Configure this background" }) }));
};
export default BackgroundRenderer;
